<h2 class="text-center" mat-dialog-title>Envio de firmas</h2>
<mat-dialog-content class="row">
  <div *ngIf="show" class="col-12 mb-4" >
    <h6 >Documentos a firmar</h6>
    <section class="section">
      <mat-checkbox class="emargin" [(ngModel)]="docu.docu.mandato" [checked]="docu.docu.mandato">Mandato</mat-checkbox>
      <mat-checkbox class="emargin"  [(ngModel)]="docu.docu.poder" [checked]="docu.docu.poder" >Poder</mat-checkbox>
      <mat-checkbox class="emargin" [(ngModel)]="docu.docu.compraVenta" *ngIf="this.data.tipo.includes('CAMBIO DE') || this.data.tipo.includes('NOTIFICACION ')"  [checked]="docu.docu.compraVenta">Contrato de compraventa</mat-checkbox>

    </section>
  </div>
  <div *ngIf="!show" class="col-12" >
    <p>{{aviso}}</p>
  </div>
  


</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-button (click)="submit()" [disabled]="!show">Enviar</button>
</mat-dialog-actions>


<div *ngIf="spinnerFirma" class="spinner swal2-container swal2-center swal2-backdrop-show">
  <img class="spinner-img" alt="" src="../../../assets/img/logo-empresa.png">
  <h4  style="margin-top: 200px; color: white">Enviando datos para la firma de documentos...</h4>
</div>

